import { SubscriptionSection } from "../interfaces/subscriptions.interfaces";

export const SUBSCRIPTION_KEYS = {
    all: ["subscriptions"] as const,
    self: (section: SubscriptionSection) => ["subscriptions", "self", section] as const,
    billingVaults: ["subscriptions", "billing-vaults"] as const,
};
